import { Stack, Typography } from '@rossum/ui/material';

type TextColumnProps = {
  value: string | undefined;
};

export const TextColumn = ({ value }: TextColumnProps) => {
  if (!value) return null;

  return (
    <Stack
      sx={{
        maxWidth: '100%',
        height: '100%',
        justifyContent: 'center',
      }}
    >
      <Typography
        color="secondary"
        variant="body2"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '100%',
        }}
      >
        {value}
      </Typography>
    </Stack>
  );
};
